import { ReactComponent as IconAnalystAdvisor } from 'assets/icons/advisors/icon-analyst-advisor.svg';
import { ReactComponent as IconPlans } from 'assets/icons/menu/marketplace/iconPlanos.svg';
import { ReactComponent as IconCourses } from 'assets/icons/menu/marketplace/iconTrilhas.svg';
// import { ReactComponent as IconServices } from 'assets/icons/menu/marketplace/iconServicos.svg';
import { SideMenuConfig } from 'types/userPlanFeaturesTypes';

export const mapSidebarMarketplace = (sideMenu?: SideMenuConfig | null) => [
  {
    name: 'Cursos',
    type: 'courses',
    title: ``,
    icon: IconCourses,
    filter: false,
    path: '',
    disabled: !sideMenu?.solutions?.courses,
  },
  {
    name: 'Mentores',
    type: 'advisor',
    title: ``,
    icon: IconAnalystAdvisor,
    filter: false,
    path: '',
    disabled: !sideMenu?.solutions?.advisors,
  },
  {
    name: 'Planos',
    type: 'plans',
    title: ``,
    icon: IconPlans,
    filter: false,
    path: '',
    disabled: !sideMenu?.solutions?.plans,
  },
  {
    name: 'Serviços',
    type: 'services',
    title: ``,
    icon: IconAnalystAdvisor,
    filter: false,
    path: '',
    disabled: !sideMenu?.solutions?.services,
  },
];
